module.exports = __webpack_public_path__ + "static/media/popular_banner.83d803ca.png";